import Home from './home/Home'

export default function IndexPage() {
  return <Home />
}
